import { DatabaseFieldType } from '@databases/types/database';
import { DatabaseViewSettings } from '@databases/types/database/view';
import { isEmptyValue } from '@databases/utils/database/field-types';
import {
  getConvertedDatabaseValue,
  getDatabaseEntryRequired,
} from '@databases/utils/database/utils';
import { getDateField } from '@databases/utils/database/view/view';

import { selectDatabaseDraftByContentId } from '../changesets/selectors';
import { DefaultRootState } from '../redux';

/**
 * Returns the entry IDs of the entries that should be shown for a specific day in the calendar layout, in order, for the database draft in
 * the given scope with the given view settings applied.
 */
export function selectCardLayoutDayEntries(
  state: DefaultRootState,
  {
    contentId,
    viewSettings,
    date,
  }: {
    contentId: string;
    viewSettings: DatabaseViewSettings;
    date: string;
  }
): string[] {
  const databaseDraft = selectDatabaseDraftByContentId(state, {
    contentId,
    scope: 'main',
    includeDeleted: true,
  });
  const databaseDraftView = selectDatabaseDraftByContentId(state, {
    contentId,
    scope: 'main',
    viewSettings,
    includeDeleted: true,
  });
  const dateField = getDateField(databaseDraft, viewSettings.layout)!;
  if (!dateField) {
    return [];
  }

  return databaseDraftView.entries.filter((entryId) => {
    const entry = getDatabaseEntryRequired(databaseDraft, entryId);
    const value = getConvertedDatabaseValue(databaseDraft, dateField, entry, state);
    return (
      value.type === DatabaseFieldType.DATE &&
      !isEmptyValue(
        { database: databaseDraftView, field: dateField, entry, value },
        state
      ) &&
      value.value === date
    );
  });
}
